query getTopTopicsCombinedUsage{
  getTopTopicsCombinedUsage {
    topicId
    topicName
    generatedTextCount
    postedContentCount
  }
}
